var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2308 8H5.76923C4.23983 8 3 9.26853 3 10.8333V22.1667C3 23.7315 4.23983 25 5.76923 25H24.2308C25.7602 25 27 23.7315 27 22.1667V10.8333C27 9.26853 25.7602 8 24.2308 8Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.44405V6.77719C23.9999 6.36837 23.9059 5.96462 23.7247 5.59475C23.5436 5.22487 23.2798 4.89798 22.9521 4.63741C22.6244 4.37684 22.241 4.18901 21.8291 4.08732C21.4172 3.98563 20.9871 3.97258 20.5694 4.04911L5.34875 6.54661C4.68777 6.66771 4.09147 7.00676 3.66269 7.5053C3.23392 8.00383 2.99954 8.63059 3 9.27747V12",
    strokeWidth: 2,
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C21.6044 19 21.2178 18.8827 20.8889 18.6629C20.56 18.4432 20.3036 18.1308 20.1522 17.7654C20.0009 17.3999 19.9613 16.9978 20.0384 16.6098C20.1156 16.2219 20.3061 15.8655 20.5858 15.5858C20.8655 15.3061 21.2219 15.1156 21.6098 15.0384C21.9978 14.9613 22.3999 15.0009 22.7654 15.1522C23.1308 15.3036 23.4432 15.56 23.6629 15.8889C23.8827 16.2178 24 16.6044 24 17C24 17.5304 23.7893 18.0391 23.4142 18.4142C23.0391 18.7893 22.5304 19 22 19Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutIcon);
export default __webpack_public_path__ + "static/media/payout-icon.e38f67924e0b9a283b7d77a0a3709125.svg";
export { ForwardRef as ReactComponent };